import React, { useState } from 'react'
import './datatable.scss'
import { Space, Input, Button, Popover } from "antd";
import type { ColumnsType } from 'antd/es/table';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { AppTable } from "../common";



interface Contentdata {
    key?: string;
    _id: string;
    id?: number; // legacy field, keeping for backward compatibility
    name: string
}
// interface DataTableProps {
//     setshowModel: (value: boolean) => void,
//     setEditable: (value: boolean) => void,
//     deleteThought: (value: any) => void,
//     editContent:(value:any)=>void
//     isOpen: boolean,
//     contentData?: Contentdata[]
// }
function DataTableTheme({ setshowModel, setEditable, isOpen, contentData, deleteThemes, editContent, showModal }: any) {

    const [searchText, setSearchText] = useState("");

    const columns: ColumnsType<Contentdata> = [

        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
            filteredValue: [searchText],
            onFilter: (value, record) => {
                return String(record.name).toLowerCase()
                    .includes(value.toLocaleString()) || String(record._id || record.id).toLowerCase()
                        .includes(value.toLocaleString())
            }
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: text => text.length > 15 ? `${text.slice(0, 100)}...` : text,
        },
           {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        className="table_pill_btn table_pill_btn--view"
                        icon={<EditOutlined />}
                        onClick={() => {
                        setshowModel(!isOpen);
                        setEditable(true);
                        editContent(record._id || record.id)
                    }}>Edit</Button>
                    <Popover
                        content={
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                                <Button style={{ backgroundColor: 'green', width: '100%', color: '#fff' }} onDoubleClick={() => deleteThemes(record._id || record.id)}>Yes</Button>
                            </div>
                        }
                        title="Please Double click to delete."
                    >
                        <Button
                            className="table_pill_btn table_pill_btn--danger"
                            icon={<DeleteOutlined />}
                        >
                            Delete
                        </Button>
                    </Popover>
                </Space>
            ),
        },
    ];


    return (
        <div className="dataTable">
            <div className="filterMenu">
                <Button onClick={showModal} className="add_button">
                    Add New Theme
                </Button>
                <Input.Search onSearch={(value) => {
                    setSearchText(value)
                }}
                    onChange={(e) => {
                        setSearchText(e.target.value)
                    }}
                    className='searchField' placeholder='Search here...' />
            </div>
            <AppTable
              className='dataGrid'
              columns={columns}
              dataSource={contentData}
            />
        </div>
    )
}

export default DataTableTheme